import React from "react";
import { SideBar } from "./../../sidebar";
import {
  updateAuction,
  getAuction,
  uploadTempDownloads,
} from "../../../../models/auctions";
import swal from "sweetalert";
import i18n from "../../../../i18n";
import { AuctionTabs } from "./../../helper/auction_tabs";
import { Spinner } from "react-bootstrap";
import FileInput from "../../../helpers/fileInput";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  ArrowLeft,
  Download,
  Expand,
  FileText,
  Loader2,
  Plus,
  Shrink,
  Trash2,
} from "lucide-react";

export class AuctionContracts extends React.Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);

    this.state = {
      auctionId: auctionId,
      input: {},
      errors: {},
      contracts: [{ label: "", label_ar: "", file: "" }],
      jsonLabel: "",
      jsonValue: "",
      is_loading: false,
      contractFile: null,
      hideSidebar: false,
      isSubmitting: false,
    };
    this.handleContractSubmit = this.handleContractSubmit.bind(this);

    this.appendData = this.appendData.bind(this);
    this.removeContractData = this.removeContractData.bind(this);
    this.setContractJson = this.setContractJson.bind(this);

    this.uploadTempDownloads = this.uploadTempDownloads.bind(this);
  }

  componentDidMount() {
    this.loadAuction();
  }

  async loadAuction() {
    this.setState({ is_loading: true });
    let id = this.state.auctionId;
    const response = await getAuction(id);
    let auction = response.data;
    if (auction) {
      let downloads = auction.downloads;
      if (downloads && downloads.length) {
        this.setState({ contracts: downloads });
      }
      this.setState({ is_loading: false });
    }
  }

  onFileChange = (event, index) => {
    console.log(event);
    console.log(index);
    if (event.target.name === "file") {
      this.uploadTempDownloads(event.target.files[0], index);
    }
  };

  async uploadTempDownloads(file, index) {
    const formData = new FormData();
    formData.append("contractFile", file, file.name);
    console.log("formData", formData);
    const response = await uploadTempDownloads(formData);
    if (response.success) {
      let { contracts } = this.state;
      contracts[index].file = response.data;
      this.setState({ contracts });
    } else {
      swal(
        "Failed",
        "Some error occured!! Please make sure that you are uploading valid file.",
        "error"
      );
    }
  }

  handleContractSubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ isSubmitting: true });
      let payload = this.state.input;
      payload.is_downloads_update = true;
      payload.downloads = this.state.contracts;
      let id = this.state.auctionId;
      const response = await updateAuction(payload, id);
      if (response && response.data && response.data.id) {
        swal(i18n.t("success"), response.message, "success", {
          buttons: false,
          timer: 2000,
        }).catch((response) => {
          swal("Failed", response.message, "error");
        });
      } else {
        let error_message = "Not found!!!";
        let error_messages = response.message;
        for (const key in error_messages) {
          if (Object.hasOwnProperty.call(error_messages, key)) {
            let element = error_messages[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  appendData(e) {
    e.preventDefault();
    let contracts = this.state.contracts || [];
    contracts.push({ label: "", value: "" });
    this.setState({ contracts: contracts });
  }

  removeContractData(key) {
    let contracts = this.state.contracts;
    delete contracts[key];
    this.setState({ contracts: contracts });
  }

  setContractJson(key, event, arrKey) {
    let contracts = this.state.contracts;
    contracts[arrKey][key] = event.target.value;
    this.setState({ contracts: contracts });
  }

  render() {
    let contracts = this.state.contracts;
    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("documents")}
          subtitle={i18n.t("manage_documents_subtitle") || "Manage auction documents and contracts"}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="contracts" />
                    <div className="create-group-container">
                      <div
                        className="form-content"
                        style={{ flexDirection: "column" }}
                      >
                        {/* Loading State */}
                        {this.state.is_loading && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "3rem",
                              background: "#f9fafb",
                              borderRadius: "8px",
                            }}
                          >
                            <Loader2
                              className="animate-spin"
                              size={24}
                              style={{ marginRight: "8px" }}
                            />
                            <span>{i18n.t("loading") || "Loading..."}</span>
                          </div>
                        )}

                        {!this.state.is_loading && (
                          <div className="form-section">
                            <div className="section-header">
                              <h2>{i18n.t("documents")}</h2>
                              <button
                                className="button1 button1-secondary"
                                onClick={this.appendData}
                                type="button"
                              >
                                <Plus size={18} /> {i18n.t("add_new")}
                              </button>
                            </div>

                            {contracts &&
                              contracts.length > 0 &&
                              contracts.map((item, i) => {
                                if (!item) return null;
                                return (
                                  <div key={i} className="enquiry-item">
                                    <div className="form-row">
                                      <div className="form-field">
                                        <label>{i18n.t("label")}</label>
                                        <input
                                          type="text"
                                          placeholder={i18n.t("label")}
                                          value={item.label || ""}
                                          onChange={(event) => {
                                            this.setContractJson(
                                              "label",
                                              event,
                                              i
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-field">
                                        <label>{i18n.t("label_ar")}</label>
                                        <input
                                          type="text"
                                          placeholder={i18n.t("label_ar")}
                                          value={item.label_ar || ""}
                                          dir="rtl"
                                          onChange={(event) => {
                                            this.setContractJson(
                                              "label_ar",
                                              event,
                                              i
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="upload-field">
                                      <label>
                                        {i18n.t("upload")} (Image/PDF/Doc)
                                      </label>
                                      {item.file ? (
                                        <div className="file-preview-container">
                                          <div className="document-preview">
                                            <div className="document-icon">
                                              <FileText
                                                size={24}
                                                strokeWidth={1.5}
                                              />
                                            </div>
                                            <div className="document-info">
                                              <span className="document-name">
                                                {item.label ||
                                                  i18n.t("document")}
                                              </span>
                                            </div>
                                            <div className="document-actions">
                                              <a
                                                href={item.file}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="preview-action-btn"
                                                title={i18n.t("download")}
                                                style={{
                                                  textDecoration: "none",
                                                  display: "inline-flex",
                                                }}
                                              >
                                                <Download size={16} />
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div
                                        style={{
                                          marginTop: item.file ? "8px" : "0",
                                        }}
                                      >
                                        <FileInput
                                          placeholder={i18n.t("choose_file")}
                                          className="form-control"
                                          name="file"
                                          onChange={(e) => {
                                            this.onFileChange(e, i);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {i > 0 && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-end",
                                          marginTop: "8px",
                                        }}
                                      >
                                        <button
                                          className="button1 button1-danger"
                                          onClick={() => {
                                            this.removeContractData(i);
                                          }}
                                          type="button"
                                        >
                                          <Trash2 size={18} />
                                          {i18n.t("remove")}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}

                            <div className="action-buttons-l2 border-top-light">
                              <button
                                className="button1 button1-gray"
                                onClick={() => window.history.back()}
                                type="button"
                                disabled={this.state.isSubmitting}
                              >
                                {i18n.t("cancel")}
                              </button>
                              <button
                                className="button1 button1-primary"
                                onClick={this.handleContractSubmit}
                                type="button"
                                disabled={this.state.isSubmitting}
                              >
                                {this.state.isSubmitting ? (
                                  <>
                                    <Loader2
                                      className="animate-spin"
                                      size={18}
                                    />
                                    <span>{i18n.t("update")}</span>
                                  </>
                                ) : (
                                  <span>{i18n.t("update")}</span>
                                )}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}